// extracted by mini-css-extract-plugin
export var container = "transition-daily-module--container--lAmec";
export var content = "transition-daily-module--content--Yi9Ay";
export var errorText = "transition-daily-module--error-text--Ei7CX";
export var header = "transition-daily-module--header--Vorql";
export var list = "transition-daily-module--list--Axaak";
export var loader = "transition-daily-module--loader--8-cCJ";
export var loading = "transition-daily-module--loading--mmgxN";
export var title = "transition-daily-module--title--sPa5p";